import React, { useState, useEffect } from "react";
import NoNotification from "../../img/no-results.png";
import { NavLink } from "react-router-dom";
import "./recentactivity.css";
import "../ProgressBySector/sectorprogress.css";

const RecentActivity = ({ todaysActivities,heading }) => {
  // State to track how many activities are loaded
  const [loadedActivities, setLoadedActivities] = useState([]);
  const [loading, setLoading] = useState(false); // For loading state

  const itemsPerLoad = 10; // Number of items to load initially and on each scroll

  // Function to load more activities
  const loadMoreActivities = () => {
    if (loading) return; // Prevent loading if already loading

    setLoading(true);

    // Get the next set of activities to load
    const nextActivities = todaysActivities.slice(loadedActivities.length, loadedActivities.length + itemsPerLoad);
    setLoadedActivities((prev) => [...prev, ...nextActivities]);

    setLoading(false);
  };

  // Load the initial set of activities when the component mounts
  useEffect(() => {
    loadMoreActivities();
  }, [todaysActivities]);

  // Handle scroll to load more data
  const handleScroll = (e) => {
    const threshold = 5;
    const bottom = Math.abs(e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight) < threshold;
    if (bottom) {
      loadMoreActivities();
    }
  };

  return (
    <div className="recentclass">
      {/* Header */}
      <div className="activity-header-wrapper">
        <h3 className="activity-header-title">{heading}</h3>
      </div>

      {/* Scrollable list */}
      <div
        className="activity_section"
        onScroll={handleScroll}
      >
        {loadedActivities.length > 0 ? (
          loadedActivities.map((notification) => (
            <div key={notification.id} className="activity-row">
              {/* User Avatar Circle */}
              <div className="circle-icon">
                <div className="name_icon">
                  {notification?.userName?.charAt(0) || "U"}
                </div>
              </div>

              {/* Message Details */}
              <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}>
                <div className="d-flex align-items-center flex-wrap">
                  <span className="name">{notification?.userName}</span>
                  <NavLink
                    className="activity-message-link"
                    onClick={() => {
                      localStorage.setItem(
                        "reportingQuestion",
                        JSON.stringify([notification?.questionId])
                      );
                    }}
                    to={{
                      pathname: "/reporting-modules/all-module",
                      state: {
                        reportingQuestion: [notification?.questionId],
                      },
                    }}
                  >
                    <span title={notification?.massage}>
                      {notification?.massage.length > 60
                        ? `${notification?.massage.slice(0, 57)}...`
                        : notification?.massage}
                    </span>
                  </NavLink>
                </div>

                {/* Timestamps */}
                <div className="activity-timestamp-container">
                  <span>
                    <i className="far fa-clock activity-timestamp-icon" aria-hidden="true" />
                    {new Date(notification?.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                  </span>
                  <span>
                    <i className="far fa-calendar-alt activity-timestamp-icon" aria-hidden="true" />
                    {new Date(notification?.createdAt).toLocaleDateString([], { day: '2-digit', month: '2-digit', year: 'numeric' })}
                  </span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="d-flex flex-column align-items-center justify-content-center w-100 py-5" style={{ height: '100%', minHeight: '300px' }}>
            <img
              src={NoNotification}
              alt="No notifications"
              style={{ width: '120px', opacity: 0.5 }}
            />
            <p className="mt-3 text-muted" style={{ fontSize: '12px' }}>No notifications here</p>
          </div>
        )}
        {loading && (
          <div className="text-center py-2">
            <div className="spinner-border spinner-border-sm text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentActivity;
